import { Plugin } from 'prosemirror-state';

export const softBreakPlugin = new Plugin({
  props: {
    handleDOMEvents: {
      keydown(view, event) {
        if (event.key === 'Enter') {
          if (!event.shiftKey) {
            const br = view.state.schema.nodes.hard_break;
            if (br) {
              const { tr } = view.state;
              tr.replaceSelectionWith(br.create());
              view.dispatch(tr);
              event.preventDefault();
              return true;
            }
          }
        }

        return false;
      },
    },
  },
});
